import styles from './kpiCard.module.css'

type Props = {
    value: string
    label: string
    count?: string
    trend?: number
    trendLabel?: string
    alert?: string
}

export const KpiCard = (props: Props) => {
    const { value, label, count, trend, trendLabel = 'vs mes anterior', alert } = props

    const trendClass = trend === undefined || trend === 0
        ? 'text-muted'
        : trend > 0 ? 'text-success' : 'text-danger'

    const trendIcon = trend === undefined || trend === 0 ? '→' : trend > 0 ? '↑' : '↓'

    return (
        <div>
            <p className={styles.value}>
                {value}
                {count !== undefined && <span className={styles.count}> ({count})</span>}
            </p>
            <span className={styles.label}>{label}</span>
            {trend !== undefined && (
                <p className={`${styles.trend} ${trendClass}`}>
                    {trendIcon} {Math.abs(trend).toFixed(1)}%
                    <span className="text-muted fw-normal ms-1">{trendLabel}</span>
                </p>
            )}
            {alert && <p className={styles.alert}>{alert}</p>}
        </div>
    )
}
